import { render, staticRenderFns } from "./PRF104M01.vue?vue&type=template&id=5fefda19&"
import script from "./PRF104M01.vue?vue&type=script&lang=js&"
export * from "./PRF104M01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports